'use client';

import React from 'react';
import styles from './styles/FullSyllabusModal.module.css';

export default function FullSyllabusModal({
  isOpen,
  onClose,
  lessons,
  user,
  teacher,
  onEditLesson,
  onDeleteLesson,
}) {
  if (!isOpen) {
    return null; // Don’t render anything if modal is closed
  }

  const handleOverlayClick = (e) => {
    // If user clicks overlay => close
    if (e.target.dataset.closeModal) {
      onClose();
    }
  };

  return (
    <div
      className={styles.modal}
      aria-hidden={isOpen ? 'false' : 'true'}
      onClick={handleOverlayClick}
    >
      <div className={styles.modalOverlay} data-close-modal />
      <div className={styles.modalDialog} role="dialog" aria-modal="true">
        {/* Close button */}
        <button
          className={styles.modalClose}
          aria-label="Close modal"
          data-close-modal
        >
          &times;
        </button>
        <h2 id="fullSyllabusTitle">Full Syllabus</h2>

        {/* Show all lessons in new style */}
        {lessons.map((lesson) => (
          <div key={lesson.id} className={styles.lessonItem}>
            <h3 className={styles.lessonTitle}>{lesson.lessonName}</h3>
            <div className={styles.lessonContent}>
              <div className={styles.lessonDesc}>
                {/* Pre-wrap preserves line breaks */}
                <p style={{ whiteSpace: 'pre-wrap' }}>{lesson.description}</p>
                {/* Admin/Teacher edit/delete */}
                {user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN' || (user?.role === 'TEACHER' && teacher?.id === user.id) ? (
                  <div className={styles.adminControls}>
                    <button
                      className={styles.editBtn}
                      onClick={() => onEditLesson(lesson.id)}>
                      Edit</button>
                    <button
                      className={styles.deleteBtn}
                      onClick={() => onDeleteLesson(lesson.id)}
                    >
                      Delete
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
